export default __webpack_public_path__ + "static/media/golo-table.5f7447a9.png";